import React, { lazy } from 'react';

import { Route, Routes } from 'react-router-dom';

import { SitesFormType } from './types';

const SitesPage = lazy(() => import('./sites.page'));
const SitesDeletionRequestPage = lazy(
  () => import('./pages/sites-deletion-request/sites-deletion-request.page'),
);
const SiteDetailPage = lazy(
  () => import('./pages/view-site-page/site-detail.page'),
);

export const SitesRoutes = () => {
  return (
    <Routes>
      <Route index element={<SitesPage />} />
      <Route path="request-deletion" element={<SitesDeletionRequestPage />} />
      <Route
        path="view/:siteUUID"
        element={<SiteDetailPage initialFormType={SitesFormType.View} />}
      />
      <Route
        path="add"
        element={<SiteDetailPage initialFormType={SitesFormType.New} />}
      />
    </Routes>
  );
};
